// Автопоказ попапа «Заказ успешно оплачен» — ровно 1 раз сразу после оплаты.
//
// Сигнал «только что оплатили» — параметр ?paid=1 в URL (платёж редиректит на
// страницу заказа с этим флагом). Открываем попап и СРАЗУ убираем параметр из
// адреса (history.replaceState) — при перезагрузке/возврате попап не повторяется.
// Постоянный признак оплаты страница берёт из БД и живёт независимо от этого флага.
// Открытие/закрытие самого попапа — общий Popup.js (data-popup-*).

const POPUP_NAME = 'order-paid';

export function initOrderPaidPopup() {
	if (!document.querySelector(`[data-popup-name="${POPUP_NAME}"]`)) return;

	const url = new URL(window.location.href);
	if (url.searchParams.get('paid') !== '1') return;

	url.searchParams.delete('paid');
	window.history.replaceState(null, '', url.pathname + url.search + url.hash);

	if (window.popup) window.popup.open(POPUP_NAME);
}
